module.exports = "<div class=\"mouse-action-section\">\n        <menu\n                v-if=\"menu.data && menu.data.length\"\n                class=\"context-menu\"\n                :data.sync=\"menu.data\"\n                :file=\"menu.file\"\n                :style=\"{\n                    top:menu.position.y+'px',\n                    left:menu.position.x+'px'\n                }\"\n        ></menu>\n    </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mouse-menu.vue
 ** module id = 105
 ** module chunks = 0
 **/